<div class="append-container">
  <br>
  <kendo-stacklayout class="grid-layout-container" [gap]="2" [align]="{ horizontal: 'start' }">
    <div *ngFor="let m of modulos">
      <div class="locker-wrapper">
        <kendo-gridlayout [rows]="m.linhas" [cols]="m.colunas" [gap]="2">
          <kendo-gridlayout-item *ngFor="let c of m.compartimentos" [col]="c.coluna" [row]="c.linha" [rowSpan]="c.linhaSpan"
            class="box rect">

            <button [class]="'botaoAlerta ' + getColor(locker, c)" kendoButton kendoTooltip [disabled]="true" style="opacity: 1; pointer-events: none; cursor: default;">
            <span class="getText">
              <small class="boxmicro" kendoTooltip>
                  {{hmiVisible(c)}}
              </small>
            </span>
            </button>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </div>
    </div>
  </kendo-stacklayout>

  <!-- legenda -->
  <br>

  <div class="legenda">
    <div class="legenda-item">
      <span class="box greybox">{{customMsgService.translate('inibido') + " / HMI"}}</span>
      <span class="space"></span>
      <span class="box redbox">{{customMsgService.translate('ocupado')}}</span>
    </div>

